export const comparePriority = (a, b) => {
    const aEmpty = a == null || a === ""
    const bEmpty = b == null || b === ""
    if (aEmpty && bEmpty) {
        return 0
    }
    if (aEmpty) {
        return 1
    }
    if (bEmpty) {
        return -1
    }
    return Number(a) - Number(b)
}
